import { TransactionIntent } from '~/contracts/common/Trade';

export enum TradeStatus {
  Active = 'Active',
  Expired = 'Expired',
  ExpiringSoon = 'ExpiringSoon',
  Pending = 'Pending',
  None = 'None'
}

export function getTradeCtaDetails(
  status: TradeStatus,
  intent: TransactionIntent,
  id: string
): { ctaHref: string; ctaText: string } {
  const isSellOrNotSure =
    intent === TransactionIntent.Sell || intent === TransactionIntent.NotSure;

  switch (status) {
    case TradeStatus.Active:
    case TradeStatus.ExpiringSoon:
      return isSellOrNotSure
        ? { ctaHref: `/sell-my-car/hub/${id}`, ctaText: 'continue' }
        : { ctaHref: '/cars', ctaText: 'shop with your trade-in' };
    case TradeStatus.Expired:
      return {
        ctaHref: `/sell-my-car/hub/${id}`,
        ctaText: 'refresh my offer'
      };
    case TradeStatus.Pending:
      return {
        ctaHref: `/sell-my-car/hub/${id}`,
        ctaText: 'view details'
      };
    default:
      return { ctaHref: '/sell-my-car', ctaText: 'get my offer' };
  }
}

export const activeTradeStatuses = {
  [TradeStatus.Active]: TradeStatus.Active,
  [TradeStatus.ExpiringSoon]: TradeStatus.ExpiringSoon
};
